import Status from 'components/Content/GameDetails/Status/Status';

export default Status;
